import React from 'react';
import { ModifierGroupState } from './modifierGroupState/ModifierGroupState';
import { ModifierGroupControlPanel } from './components/ModifierGroupControlPanel/ModifierGroupControlPanel';
import { ModifierGroupsList } from './components/ModifierGroups/ModifierGroups';
import { ModalWindows } from './components/ModalWindows';
import style from './index.module.scss';

export const ModifierGroupsPageV2: React.FC = () => {
	return (
		<ModifierGroupState>
			<div className={style.container} data-test="ModifierGroupsPage">
				<ModifierGroupControlPanel />
				<ModifierGroupsList />
				<ModalWindows />
			</div>
		</ModifierGroupState>
	);
};
